import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_WHITE } from '@/lib/logos';
import { useI18n } from '@/lib/I18nContext';

export default function PublicFooter() {
  const { t } = useI18n();
  return (
    <footer className="py-10 px-6" style={{ background: '#070B14', borderTop: '1px solid #1E2D45' }}>
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
        {/* Logo + tagline */}
        <div className="flex flex-col items-center lg:items-start gap-1.5 text-center lg:text-left shrink-0">
          <img
            src={LOGO_WHITE}
            alt="Bezkraen"
            className="h-6 w-auto object-contain"
          />
          <p className="whitespace-nowrap" style={{ fontSize: 12, color: '#94A3B8', letterSpacing: '0.03em' }}>{t('landing.footer_tagline')}</p>
        </div>

        {/* Legal links — wrap as a group, nunca se corta el texto de un link individual */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-white/40">
          <Link to="/terms-of-service" className="hover:text-white/70 transition-colors whitespace-nowrap">{t('landing.footer_terms')}</Link>
          <Link to="/privacy-policy" className="hover:text-white/70 transition-colors whitespace-nowrap">{t('landing.footer_privacy')}</Link>
          <Link to="/data-deletion" className="hover:text-white/70 transition-colors whitespace-nowrap">{t('landing.footer_data_deletion')}</Link>
          <Link to="/calculadora-precios" className="hover:text-white/70 transition-colors whitespace-nowrap">{t('landing.footer_calculator')}</Link>
          <a href="mailto:ventas@bezkraen.com" className="hover:text-white/70 transition-colors whitespace-nowrap">{t('landing.footer_contact')}</a>
        </div>

        {/* Copyright */}
        <p className="text-white/30 text-sm text-center lg:text-right whitespace-nowrap shrink-0">{t('landing.footer_rights')}</p>
      </div>
    </footer>
  );
}